import type { TV2User } from "../global";

const CORAL_TOKEN_KEY = 'coral_token';
const CORAL_TOKEN_EXPIRY_KEY = 'coral_token_expiry';
const CORAL_TOKEN_USER_ID_KEY = 'coral_token_user_id';

export function clearCoralTokenCache(): void {
  localStorage.removeItem(CORAL_TOKEN_KEY);
  localStorage.removeItem(CORAL_TOKEN_EXPIRY_KEY);
  localStorage.removeItem(CORAL_TOKEN_USER_ID_KEY);
}

export const initCoral = () => {
  const { coralJwtUrl } = window.AUTH0_CONFIG;

  const getCoralToken = async function () {
    try {
      const accessToken = await window.TV2?.getToken();
      if (!accessToken) {
        clearCoralTokenCache();
        throw new Error('User not authenticated');
      }

      const user = await window.TV2?.getLoggedInUser() as TV2User;

      if (!user || !user.id || !user.email) {
        clearCoralTokenCache();
        throw new Error('User not authenticated or missing required fields');
      }

      if (!user.emailConfirmed) {
        clearCoralTokenCache();
        throw new Error('User email not confirmed');
      }

      const cachedToken = localStorage.getItem(CORAL_TOKEN_KEY);
      const cachedExpiry = localStorage.getItem(CORAL_TOKEN_EXPIRY_KEY);
      const cachedUserId = localStorage.getItem(CORAL_TOKEN_USER_ID_KEY);

      if (
        cachedToken &&
        cachedExpiry &&
        cachedUserId === user.id &&
        Date.now() < parseInt(cachedExpiry, 10)
      ) {
        return cachedToken;
      }

      if (cachedToken && cachedUserId !== user.id) {
        clearCoralTokenCache();
      }

      const response = await fetch(coralJwtUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to get coral token: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success || !data.token) {
        throw new Error('Invalid coral token response');
      }

      const expiryTime = Date.now() + (data.expiresIn * 1000);
      localStorage.setItem(CORAL_TOKEN_KEY, data.token);
      localStorage.setItem(CORAL_TOKEN_EXPIRY_KEY, expiryTime.toString());
      localStorage.setItem(CORAL_TOKEN_USER_ID_KEY, user.id);

      return data.token;
    } catch (error) {
      console.error('Menu: Error fetching Coral token:', error);
      clearCoralTokenCache();
    }
  };

  window.TV2 = window.TV2 || {};
  window.TV2 = { ...window.TV2, getCoralToken };

  getCoralToken();
};
